<div class="search-banner">
  <div class="search-banner-selection">
    <div class="search-banner-selection__button" (click)="toggleTagsList()">
      <p class="search-banner-selection__label">{{ 'marketplace.search.service.label'|transloco }}</p>
      <div class="search-banner-selection__current">
      @if (selectedTags === null) {
        <input class="search-banner-selection__value"
               [placeholder]="'marketplace.search.service.choose'|transloco"
               [(ngModel)]="tagSearchQuery"
               type="text"
               #tagInput
        />
      } @else if (selectedTags.length === 0) {
        <input class="search-banner-selection__value"
               [placeholder]="'marketplace.photographer.tags.all'|transloco"
               [(ngModel)]="tagSearchQuery"
               type="text"
               #tagInput
        />
      } @else {
        <input class="search-banner-selection__value"
               [placeholder]="('marketplace.photographer.tags.' + selectedTags[0].label)|transloco"
               [(ngModel)]="tagSearchQuery"
               type="text"
               #tagInput
        />
      }
      </div>
    </div>
    @if (tagsListIsOpened) {
      <div class="search-banner-selection__options"
        >
        <div class="search-banner-selection__options-option"
             (click)="selectTag(null)"
        >
          <div class="search-banner-selection__options-image">🟢</div>
          <p class="search-banner-selection__options-label">
            {{('marketplace.photographer.tags.all')|transloco}}
          </p>
        </div>
        @for (tag of filteredTags; track tag) {
          <div class="search-banner-selection__options-option"
            (click)="selectTag(tag)"
            >
            <div class="search-banner-selection__options-image">
              <p>{{tag.icon}}</p>
            </div>
            <p class="search-banner-selection__options-label">
              {{('marketplace.photographer.tags.' + tag.label)|transloco}}
            </p>
          </div>
        }
      </div>
    }
  </div>

  <div class="search-banner-selection">
    <div class="search-banner-selection__button" (click)="toggleCityList()">
      <p class="search-banner-selection__label">{{'marketplace.search.city.label'|transloco}}</p>
      <div class="search-banner-selection__current">
        @if (selectedCity === null) {
          <input class="search-banner-selection__value"
                 [placeholder]="'marketplace.search.city.all'|transloco"
                 [(ngModel)]="citySearchQuery"
                 (ngModelChange)="onCitySearchQueryChanged($event)"
                 type="text"
                 #cityInput
          />
        } @else {
          <input class="search-banner-selection__value"
                 [placeholder]="selectedCity"
                 [(ngModel)]="citySearchQuery"
                 (ngModelChange)="onCitySearchQueryChanged($event)"
                 type="text"
                 #cityInput
          />
        }
      </div>
    </div>
    @if (cityListIsOpened) {
      <div class="search-banner-selection__options"
        >
        <div class="search-banner-selection__options-option"
             (click)="selectCity(null)"
        >
          <p class="search-banner-selection__options-label">
            {{('marketplace.search.city.all')|transloco}}
          </p>
        </div>
        @if (citySearchLoading) {
          <div class="search-banner-selection__options-option skeleton-loading"></div>
          <div class="search-banner-selection__options-option skeleton-loading"></div>
          <div class="search-banner-selection__options-option skeleton-loading"></div>
          <div class="search-banner-selection__options-option skeleton-loading"></div>
          <div class="search-banner-selection__options-option skeleton-loading"></div>
        } @else {
          @for (city of filteredCities; track city) {
            <div class="search-banner-selection__options-option" (click)="selectCity(city)">
              <p class="search-banner-selection__options-label">{{city}}</p>
            </div>
          }
        }
      </div>
    }
  </div>

  <button class="button button--large">
    <i class="fa-solid fa-magnifying-glass"></i>
  </button>
</div>

<div class="search-banner__mobile-button" (click)="openMobileSearch()">
  <p>
    {{'marketplace.search.mobile.title'|transloco}}
    <i class="fa-solid fa-magnifying-glass"></i>
  </p>
</div>

<app-sheet
  [open]="mobileSearchOpen"
  (closed)="closeMobileSearch()"
  class="search-banner__mobile"
>
  <div class="search-banner__mobile-modal-content">
    <h2 class="search-banner__mobile-modal-content-title">{{'marketplace.search.mobile.title'|transloco}}</h2>

    <div class="search-banner-selection">
      <div class="search-banner-selection__button" (click)="toggleTagsList()">
        <p class="search-banner-selection__label">{{ 'marketplace.search.service.label'|transloco }}</p>
        <div class="search-banner-selection__current">
          @if (selectedTags === null) {
            <p class="search-banner-selection__value">{{ 'marketplace.search.service.choose'|transloco }}</p>
          } @else if (selectedTags.length === 0) {
            <p class="search-banner-selection__value">{{ 'marketplace.photographer.tags.all'|transloco }}</p>
          } @else {
            <p class="search-banner-selection__value">{{ ('marketplace.photographer.tags.' + selectedTags[0].label)|transloco }}</p>
          }
        </div>
      </div>
      @if (tagsListIsOpened) {
        <div class="search-banner-selection__options"
        >
          <div class="search-banner-selection__options-option"
               (click)="selectTag(null)"
          >
            <div class="search-banner-selection__options-image">🟢</div>
            <p class="search-banner-selection__options-label">
              {{('marketplace.photographer.tags.all')|transloco}}
            </p>
          </div>
          @for (tag of allTags; track tag) {
            <div class="search-banner-selection__options-option"
                 (click)="selectTag(tag)"
            >
              <div class="search-banner-selection__options-image">
                <p>{{tag.icon}}</p>
              </div>
              <p class="search-banner-selection__options-label">
                {{('marketplace.photographer.tags.' + tag.label)|transloco}}
              </p>
            </div>
          }
        </div>
      }
    </div>

    <div class="search-banner-selection">
      <div class="search-banner-selection__button" (click)="toggleCityList()">
        <p class="search-banner-selection__label">{{'marketplace.search.city.label'|transloco}}</p>
        <div class="search-banner-selection__current">
          @if (selectedCity === null) {
            <p class="search-banner-selection__value">{{ 'marketplace.search.city.all'|transloco }}</p>
          } @else {
            <p class="search-banner-selection__value">{{selectedCity}}</p>
          }
        </div>
      </div>
      @if (cityListIsOpened) {
        <div class="search-banner-selection__options"
        >
          <div class="search-banner-selection__options-option"
               (click)="selectCity(null)"
          >
            <p class="search-banner-selection__options-label">
              {{('marketplace.search.city.all')|transloco}}
            </p>
          </div>
          @for (city of popularCities; track city) {
            <div class="search-banner-selection__options-option" (click)="selectCity(city)">
              <p class="search-banner-selection__options-label">{{city}}</p>
            </div>
          }
        </div>
      }
    </div>

    <button class="button button--large button--full-width"
            (click)="closeMobileSearch()"
    >
      {{'marketplace.search.mobile.title'|transloco}}
      <i class="fa-solid fa-magnifying-glass"></i>
    </button>
  </div>
</app-sheet>
